<template>
  <div>项目信息</div>
</template>

<script>
  export default {
    name: "project-data"
  }
</script>

<style scoped>

</style>
